import styled, {keyframes, css} from 'styled-components'

const slideLeft =  before => keyframes`
    from {
        transform: translateX(${before + 21}%);
    }
    to {
        transform: translateX(${before}%);
    }

`

const slideRight =  before => keyframes`
    from {
        transform: translateX(${before - 21}%);
    }
    to {
        transform: translateX(${before}%);
    }

`

export const CarouselContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Hour = styled.div`
    height: 70px;
    margin-top: 10px;
`

export const SliderDays = styled.div`
    width: 90%;
    display: flex;
    align-items: center;
    overflow-x: hidden;
`

export const ArrowLeft = styled.div`
    color: ${props => props.disabled ? '#fff' : '#2E2D37'};
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    visibility: ${props => props.disabled ? 'hidden' : 'visible'};
    transition: all 0.2s;
    font-size: 36px;
    background-color: #fff;
    cursor: pointer;
    user-select: none;
`
export const ArrowRight = styled.div`
    color: ${props => props.disabled ? '#fff' : '#2E2D37'};
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    visibility: ${props => props.disabled ? 'hidden' : 'visible'};
    font-size: 36px;
    background-color: #fff;
    cursor: pointer;
    user-select: none;
`

export const Carousel = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    animation: ${props => !props.pressedLeft && (props.slideLeft && css`${slideLeft(props.slideLeft)} ${props.animate ? '.3s' : '0s'} linear 0s 1 normal forwards`) };
    animation: ${props => props.pressedLeft && (props.slideRight && css`${slideRight(props.slideRight)} ${props.animate ? '.3s' : '0s'} linear 0s 1 normal forwards`) };
`

export const Slide = styled.div`
    border: 1px solid #fff;
    border-color: ${props => props.isSelected && '#F3123C'};
    transition: ${props => props.animateBorder && 'all 0.7s'};
    border-radius: 8px;
    padding: 10px;
    flex-basis: 14%;
    flex-shrink: 0;
    margin-right: 7%;
    cursor: pointer;

    h3, h2 {
        color: ${props => props.isGray && ' #AEAEBA !important'};
    }
`

export const HourInfo = styled.h3`
    color: #2E2D37;
    letter-spacing: 0.1em;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    user-select: none;
`
